<template>
  <div class="Offre" style="margin-top: 100px !important">
    <Navbar title="Yajobici" />

    <div class="container-fluid p-0">
      <div class="container">
        <div class="main-body">

          <!-- Breadcrumb -->
          <nav aria-label="breadcrumb" class="main-breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link to="/" style="color: #4e585d !important"
                  >Accueil</router-link
                >
              </li>
              <li class="breadcrumb-item">
                <router-link
                  to="/nos-services"
                  style="color: #4e585d !important"
                  >Prestataires</router-link
                >
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                Détails
              </li>
            </ol>
          </nav>
          <!-- /Breadcrumb -->

          <div v-if="loading" class="row text-center">
            <div class="col-md-12">
              <span>Chargement des services en cours ...</span>
            </div>
          </div>

          <div v-else class="tabs">
            <!-- tabs 1 start -->
            <div class="tab-2">
              <label for="tab2-1" style="color: #4e585d !important"
                >Je me présente</label
              >
              <input
                id="tab2-1"
                name="tabs-two"
                type="radio"
                checked="checked"
              />

              <div class="services__list1">
                <!-- presentation du prestataire start -->
                <div class="row">
                  <div class="col-lg-2"></div>
                  <div class="col-lg-3">
                    <div class="card p-3" style="width: 15rem !important">
                      <img
                        :src="sActeurData.photo_url || '../../assets/img/avatar.png'"
                        @error="handleImageError"
                        alt="img"
                        class="img-thumbnail"
                        width="200"
                      />

                    </div>
                  </div>
                  <div class="col-lg-5">
                    <h3 class="mt-4" style="text-transform: uppercase; font-weight: 900;">
                      {{ sActeurData.full_name }}
                    </h3>

                    <p class="mb-3">
                      {{ sActeurData.description }}
                    </p>

                    <p class="mb-3" style="font-size: 20px !important;">
                      Je propose des services de :
                      <span class="presentation_items"
                       style="font-size: 20px !important;" >
                        {{ sActeurData.metier }}</span
                      >
                    </p>

                    <p class="mb-2" style="font-size: 20px !important;">
                      Je suis localisé (e) à :
                      <span class="presentation_items" style="font-size: 20px !important;">{{
                        sActeurData.adresse
                      }}</span>
                    </p>

                  </div>
                  <div class="col-md-2"></div>
                </div>
              </div>
            </div>
            <!-- tabs 1 end -->

            <!--  tabs 2 (start) -->
            <div class="tab-2">
              <label for="tab2-2" style="color: #4e585d !important"
                >Mes Services</label
              >
              <input id="tab2-2" name="tabs-two" type="radio" />

              <!-- liste des services du prestataire (start) -->
              <div class="ser">
                <div v-if="acteurServices.length == 0" class="text-center">
                  <span>Pas de service disponible</span>
                </div>
                <div
                  v-else
                >
                  <p class="text-center" style="color: #f7a51b; font-size: 20px;">
                    Pour effectuer une demande, veuillez utiliser l'application
                    mobile s'il vous plaît.
                  </p>
                <div class="row">
                  <div class="col-md-2"></div>

                  <div class="col-md-8">

                      <div class="container my-4">

                        <!-- Barre de recherche -->
                        <div class="mb-4">
                          <input
                            v-model="search"
                            type="text"
                            class="form-control search-input"
                            placeholder="Rechercher un service..."
                          />
                        </div>

                        <!-- Services -->
                        <div class="row">
                          <div
                            class="col-md-6 col-lg-4 mb-4"
                            v-for="data in paginatedServices"
                            :key="data.id"
                          >
                            <div class="service-card">
                              <h5 class="service-title">
                                {{ data.service?.libelle }}
                              </h5>

                              <div class="service-price">
                                {{ data.prix_min }} F CFA
                              </div>

                              <!-- <button class="btn btn-primary w-100 mt-3">
                                Voir détail
                              </button> -->
                            </div>
                          </div>
                        </div>

                        <!-- Pagination -->
                        <div class="d-flex justify-content-center mt-4">
                          <button
                            class="btn btn-light me-2"
                            :disabled="currentPage === 1"
                            @click="currentPage--"
                          >
                            Précédent
                          </button>

                          <span class="align-self-center">
                            Page {{ currentPage }} / {{ totalPages }}
                          </span>

                          <button
                            class="btn btn-light ms-2"
                            :disabled="currentPage === totalPages"
                            @click="currentPage++"
                          >
                            Suivant
                          </button>
                        </div>

                      </div>

                  </div>

                  <div class="col-md-2"></div>
                </div>
                  
                 
                </div>

              </div>
              <!-- liste des services du prestataire (end) -->

              

            </div>
            <!-- tabs 2 end -->

          </div>
          <!-- ends tabs -->

        </div>
        <!-- end  main body -->

      </div>
      <!-- end  container -->

      <!-- Footer Start -->
      <Footer />
      <!-- Footer End -->

      <!-- modal réservation start -->
      <div
        class="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="staticBackdropLabel">Réservation</h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body p-4">
              <section class="">
                <div>
                  <span style="font-size: 15px; color: #f7a51b"
                    >- Manucure et pose vernis semi-permanant
                  </span>
                </div>

                <div class="py-2 mt-3 text-center" style="font-size: 13px">
                  Veuillez sélectionner la date et l'heure à laquelle vous
                  souhaiterez avoir cette prestation
                </div>

                <form class="mt-2">
                  <div class="mb-3 row">
                    <label for="inputPassword" class="col-sm-2 col-form-label"
                      >Date</label
                    >
                    <div class="col-sm-10">
                      <input
                        type="date"
                        class="form-control"
                        id="inputPassword"
                      />
                    </div>
                  </div>
                  <div class="mb-3 row">
                    <label for="inputPassword" class="col-sm-2 col-form-label"
                      >Heure</label
                    >
                    <div class="col-sm-10">
                      <input
                        type="time"
                        class="form-control"
                        id="inputPassword"
                      />
                    </div>
                  </div>
                </form>
              </section>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn"
                style="color: #ffffff; background-color: #f7a51b"
                data-bs-dismiss="modal"
              >
                Annuler
              </button>
              <button
                type="submit"
                class="btn"
                style="color: #ffffff; background-color: #61c7f2"
              >
                Enregistrer
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- modal réservation start -->

    </div>
    <!-- end  container-fluid -->
  </div>
  <!-- end  div.offre -->
</template>




<script>
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "Offre",

  components: {
    Navbar,
    Footer,
  },

  data() {
    return {
      loading: false,
      acteurServices: [],
      sActeurData: [],

      // Recherche & pagination
      search: "",
      currentPage: 1,
      perPage: 6,
    };
  },

  mounted() {
    this.getServicesList();

    const storageData = localStorage.getItem("selectedUserData");
    if (storageData) {
      this.sActeurData = JSON.parse(storageData);
    }
  },

  computed: {
    filteredServices() {
      if (!this.search) return this.acteurServices;

      return this.acteurServices.filter((item) =>
        item.service?.libelle
          ?.toLowerCase()
          .includes(this.search.toLowerCase())
      );
    },

    paginatedServices() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.filteredServices.slice(start, start + this.perPage);
    },

    totalPages() {
      return Math.ceil(this.filteredServices.length / this.perPage);
    },
  },

  watch: {
    search() {
      this.currentPage = 1;
    },
  },

  methods: {
    handleImageError(event) {
      event.target.src = require('../../assets/img/avatar.png');
    },

    async getServicesList() {
      this.loading = true;

      const data = {
        prestataireId: this.$route.params.prestataireId,
        metierId: this.$route.params.metierId,
      };

      await this.$store
        .dispatch("staticdata/fetchPrestataireService", data)
        .then(
          (response) => {
            this.loading = false;
            this.acteurServices = response.data;
          },
          (error) => {
            this.loading = false;
            console.log("error--- ", error);
          }
        );
    },
  },
};
</script>

<style scoped>

.search-input {
  border-radius: 50px;
  padding: 12px 20px;
}

.service-card {
  background: #fff;
  padding: 20px;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  height: 100%;
  border: 1px solid #61c7f2;
}

.service-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px #61c7f28a;

}

.service-title {
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 10px;
}

.service-price {
  font-size: 16px;
  font-weight: bold;
  color: #f7a51b;
  text-align: center !important;
  align-items: center !important;
  padding: 1px !important;
  border: 1px dotted#f7a51b;
  border-radius: 15px !important;
}
body {
  background-color: #e2e8f0;
}

.ServIce{
  padding: 10px !important;
  margin: 0% !important;
  font-size: 18px !important;
  font-weight: 700;
}
.ServIce2{
  background-color: #61c7f28a;
  border-radius: 10px;
}
.breadcrumb .active {
  color: #61c7f2 !important;
}
.breadcrumb-item {
  color: #4e585d !important;
}

.page-link {
  color: #61c7f2 !important;
}
.page-link:active {
  color: #f7a51b !important;
}
.main-body {
  padding: 15px;
}
.card {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}

h1 {
  text-align: center;
  font-weight: 700;
  color: rgb(70, 70, 70);
  margin-bottom: 0px;
  letter-spacing: 2px;
}


.presentation_items {
  font-size: 15px !important;
  font-weight: bolder !important;
  color: #f7a51b !important;
}

h1 {
  font-size: 40px;
  line-height: 0.8em;
  color: rgba(255, 255, 255, 0.2);
}

.tabs {
  display: block;
  display: -webkit-flex;
  display: -moz-flex;
  display: flex;
  -webkit-flex-wrap: wrap;
  -moz-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 0;
  overflow: hidden;
}
.tabs [class^="tab"] label,
.tabs [class*=" tab"] label {
  color: #efedef;
  cursor: pointer;
  display: block;
  font-size: 1.1em;
  font-weight: 300;
  line-height: 1em;
  padding: 2rem 0;
  text-align: center;
}
.tabs [class^="tab"] [type="radio"],
.tabs [class*=" tab"] [type="radio"] {
  border-bottom: 1px solid rgba(239, 237, 239, 0.5);
  cursor: pointer;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: block;
  width: 100%;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}
.tabs [class^="tab"] [type="radio"]:hover,
.tabs [class^="tab"] [type="radio"]:focus,
.tabs [class*=" tab"] [type="radio"]:hover,
.tabs [class*=" tab"] [type="radio"]:focus {
  border-bottom: 1px solid #f7a51b;
}
.tabs [class^="tab"] [type="radio"]:checked,
.tabs [class*=" tab"] [type="radio"]:checked {
  border-bottom: 2px solid #f7a51b;
}
.tabs [class^="tab"] [type="radio"]:checked + div,
.tabs [class*=" tab"] [type="radio"]:checked + div {
  opacity: 1;
}
.tabs [class^="tab"] [type="radio"] + div,
.tabs [class*=" tab"] [type="radio"] + div {
  display: block;
  opacity: 0;
  padding: 2rem 0;
  width: 90%;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}
.tabs .tab-2 {
  width: 50%;
}
.tabs .tab-2 [type="radio"] + div {
  width: 200%;
  margin-left: 200%;
}
.tabs .tab-2 [type="radio"]:checked + div {
  margin-left: 0;
}
.tabs .tab-2:last-child [type="radio"] + div {
  margin-left: 100%;
}
.tabs .tab-2:last-child [type="radio"]:checked + div {
  margin-left: -100%;
}
</style>
